import React from 'react'
import PropTypes from 'prop-types'
import { SectionWrapper } from '../Section'
import SuccessMessage from '../SuccessMessage'
import CircularProgress from '../CircularProgress'

function LoadingMessage({ children }) {
  return (
    <SectionWrapper align='center'>
      <CircularProgress size={80} />
      <SuccessMessage>
        {children}
      </SuccessMessage>
    </SectionWrapper>
  )
}

LoadingMessage.propTypes = {
  children: PropTypes.node.isRequired
}

export default LoadingMessage
